/**
 * Created by sisy on 2017/8/23.
 */
import TYPES from './mutation-types';
import store from '@/store'
// import {get_fast_menu, set_fast_menu} from '../api/home'
import { Notification } from 'element-ui'
// import { change_html_title } from '../mixins/changeHtmlTitle';

export default {
//   get_fast_menu ({ commit, rootState }) {
//     get_fast_menu().then((data) => {
//       commit(TYPES.GET_FAST_MENU, {groups: data.groups, appPris: rootState.user.applicationprivileges})
//     }, () =>{})
//   },
//   set_fast_menu({commit}, {menus, e}){
//     // // 格式化快捷菜单
//     // let datas = menus.map(menu => ({
//     //   appKey: menu.appKey,
//     //   image: menu.image,
//     //   name: menu.name,
//     //   thumbnail:
//     // }));
//     if(menus.length > 10){
//         commit(TYPES.OVER_FASTMENUS_LENGTH);
//     }else{
//         e.disable();
//         set_fast_menu({value: menus.slice(0, 10)}).then((data) => {
//           e.close('修改快捷菜单成功');
//           store.dispatch('main/get_fast_menu')
//         }, () =>{});
//     }
//   },
  set_active_fast_menu ({commit, dispatch}, menu) {
      commit(TYPES.SET_ACTIVE_FAST_MENU, menu)
  },
  big_menu ({ commit, state }){
      // 保存状态到localStorage
      if(state.isBigMenu){
          window.set_localStorage('isBigMenu', false)
      }else {
          window.set_localStorage('isBigMenu', true)
      }
    commit(TYPES.CHANGE_MENU_SIZE)
  },
  hover_menu({ commit, state }, index){
    commit(TYPES.CHANGE_HOVER_MENU, index)
  },
  hide_menu({ commit, state}){
      // 保存状态到localStorage
      if(state.isHideMenu){
          window.set_localStorage('isHideMenu', false)
      }else {
          window.set_localStorage('isHideMenu', true)
      }
    commit(TYPES.HIDE_MENU)
  },
  set_menu_height({ commit, state, dispatch }, {height, tableHeight}){
      // 从localStorage中读取隐藏菜单和扩展菜单
//       let isHideMenu = window.get_localStorage('isHideMenu');
//       if(isHideMenu !== null && isHideMenu !== state.isHideMenu){
//           dispatch('hide_menu');
//       }
//       let isBigMenu = window.get_localStorage('isBigMenu');
//       if (isBigMenu !== null && isBigMenu !== state.isBigMenu) {
//           dispatch('big_menu')
//       }
    commit(TYPES.SET_MENU_HEIGHT, {height, tableHeight})
  },
  set_home_scrollTop({commit}, scrollTop){
    commit(TYPES.SET_HOME_SCROLLTOP, scrollTop)
  },

  start_loading({ commit }) {
    commit(TYPES.LOADING_START);
  },
  end_loading({ commit }) {
    commit(TYPES.LOADING_END);
  },
  // 设置系统信息
  set_system_info({ commit, state }, data) {
    commit(TYPES.SET_SYSTEM_INFO, JSON.parse(data));
    // change_html_title(state.systemInfo.htmlTitle);
  },
};
